import { defineComponent, PropType, reactive, computed, getCurrentInstance, createApp, onMounted, onBeforeUnmount, ref, provide, inject } from 'vue'
import './create-global-modal.css'
import { defer } from './defer'

interface IModalOption {
  content: () => JSX.Element
  title: string
  cancel?: () => boolean | void
  ok?: () => boolean | void
}

const GlobalModalComponent = defineComponent({
  props: {
    option: {
      type: Object as PropType<IModalOption>,
      required: true
    }
  },
  setup(props) {
    const el = ref({} as HTMLElement)
    const ctx = getCurrentInstance()

    const state = reactive({
      option: props.option,
      isShow: false,
      mounted: (() => {
        const dfd = defer()
        onMounted(() => setTimeout(() => dfd.resolve(), 0))
        return dfd.promise
      })()
    })

    const service = (option: IModalOption) => {
      state.option = option
      methods.show()
    }
    Object.assign(ctx?.proxy, { service })

    const methods = {
      show: async () => {
        await state.mounted
        state.isShow = true
      },
      hide: () => {
        state.isShow = false
      }
    }

    const classes = computed(() => [
      'global-modal',
      {
        'global-modal-show': state.isShow
      }
    ])

    // 取消
    function cancel() {
      const res = props.option.cancel && props.option.cancel()
      if (res !== false) methods.hide()
    }

    // 确认
    function ok() {
      const res = props.option.ok && props.option.ok()
      if (res !== false) methods.hide()
    }

    return () => {
      return (
        <div class={classes.value} ref={el}>
          <div class="global-modal-bg" onClick={methods.hide}></div>
          <div class="global-modal-con">
            <div class="modal-header">
              <div class="modal-title">{state.option.title || '弹框'}</div>
              <div class="modal-close" onClick={methods.hide}>
                x
              </div>
            </div>
            <div class="modal-body">{state.option.content()}</div>
            <div class="modal-footer">
              {state.option.cancel ? (
                <button class="ant-btn ant-btn--default" onClick={cancel}>
                  关闭
                </button>
              ) : null}
              {state.option.ok ? (
                <button class="ant-btn ant-btn-primary" onClick={ok}>
                  确定
                </button>
              ) : null}
            </div>
          </div>
        </div>
      )
    }
  }
})

export const CreateGlobalModal = (() => {
  let ctx: any
  return (option: IModalOption) => {
    if (!ctx) {
      const el = document.createElement('div')
      document.body.appendChild(el)
      const app = createApp(GlobalModalComponent, { option })
      ctx = app.mount(el)
    }
    ctx.service(option)
  }
})()
